import React, { useContext } from "react";
import { IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { PAGE_SIZE } from "../../constants/constants";
import { debounce } from 'lodash';
import SearchContext from "../../context/search/SearchContext";
import { formatTotalElements } from "../../utils/antibody";

export const TablePaginatedFooter = () => {
  const { totalElements, currentPage=0, setCurrentPage=() => {} } = useContext(SearchContext);

  const handleNextPage = debounce(() => {
    setCurrentPage(currentPage + 1)
  }, 800)

  const handlePrevPage = debounce(() => {
    setCurrentPage(currentPage - 1)
  }, 800)

  const startPageCount = totalElements ? (currentPage - 1) * PAGE_SIZE + 1 : 0;
  const endPageCount = totalElements ? (currentPage * PAGE_SIZE > totalElements ? totalElements : currentPage * PAGE_SIZE) : 0;
  return currentPage && totalElements ? (
    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", padding: '0.75rem 1.5rem 1rem 1.5rem' }}>
      <div>
        {startPageCount}-
        {endPageCount} {' '}
        of {formatTotalElements(totalElements)} results
      </div>
      <div>
        <IconButton style={{ cursor: 'pointer' }} onClick={() => handlePrevPage()} disabled={currentPage <= 1}>
          <ChevronLeft />
        </IconButton>
        <IconButton style={{ cursor: 'pointer' }} onClick={() => handleNextPage()} disabled={currentPage >= Math.ceil(totalElements / PAGE_SIZE)}>
          <ChevronRight />
        </IconButton>

      </div>
    </div>
  ) : null;
}